<template>
  <GameLanding />
</template>

<script setup>
import GameLanding from './components/GameLanding.vue'
</script>

<style>
* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

#app {
  width: 100%;
}
</style>
